// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Widget/Punctuality/KpiSection" (18906:122099). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const widgetPunctualityKpisectionContract = {
    component: 'Widget/Punctuality/KpiSection',
    nodeId: '18906:122099',
    section: 'Punctuality · Components',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [
        {
            component: 'SeverityItem',
            variants: [
                'variant=critical, size=small',
                'variant=success, size=small',
                'variant=warning, size=small',
            ],
        },
        { component: 'Widget/Punctuality/DirectionLabel', variants: [] },
        {
            component: 'Widget/Punctuality/KpiDirection',
            variants: [
                'direction=arrivals, layout=stacked',
                'direction=arrivals, layout=wide',
                'direction=departures, layout=stacked',
                'direction=departures, layout=wide',
            ],
        },
        { component: 'Widget/Stat/CountLabel', variants: ['size=inline'] },
        { component: 'Widget/Stat/SeverityBar', variants: ['status=success', 'status=warning'] },
        {
            component: 'Widget/Stat/TrendMeasure',
            variants: [
                'size=inline, trend=critical, labelPosition=inline, emphasis=default',
                'size=inline, trend=success, labelPosition=inline, emphasis=default',
                'size=small, trend=critical, labelPosition=inline, emphasis=default',
                'size=small, trend=success, labelPosition=inline, emphasis=default',
            ],
        },
    ],
    stateAxis: null,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [] as readonly ContractDisagreement[],
    textStyleIds: [],
    props: {
        detailed: { kind: 'enum', values: ['off', 'on'] },
        size: { kind: 'enum', values: ['tile', 'S', 'M', 'L'] },
    },
    variants: {
        'size=L, detailed=on': {
            container: 'gap-2xl w-[52.5rem] items-start',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: 'bg-border-subtle w-[0.0625rem]',
            parts: {
                departures: 'gap-2xl items-start',
                divider: 'bg-border-subtle w-[0.0625rem]',
                arrivals: 'gap-2xl items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [
                {
                    component: 'SeverityItem',
                    variants: [
                        'variant=critical, size=small',
                        'variant=success, size=small',
                        'variant=warning, size=small',
                    ],
                },
                { component: 'Widget/Punctuality/DirectionLabel', variants: [] },
                {
                    component: 'Widget/Punctuality/KpiDirection',
                    variants: [
                        'direction=arrivals, layout=wide',
                        'direction=departures, layout=wide',
                    ],
                },
                { component: 'Widget/Stat/CountLabel', variants: ['size=inline'] },
                {
                    component: 'Widget/Stat/SeverityBar',
                    variants: ['status=success', 'status=warning'],
                },
                {
                    component: 'Widget/Stat/TrendMeasure',
                    variants: [
                        'size=inline, trend=critical, labelPosition=inline, emphasis=default',
                        'size=inline, trend=success, labelPosition=inline, emphasis=default',
                        'size=small, trend=critical, labelPosition=inline, emphasis=default',
                        'size=small, trend=success, labelPosition=inline, emphasis=default',
                    ],
                },
            ],
        },
        'size=M, detailed=on': {
            container: 'gap-s w-[27.125rem] items-start',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                cols: 'gap-m items-start',
                departures: 'gap-s items-start',
                arrivals: 'gap-s items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [
                {
                    component: 'SeverityItem',
                    variants: [
                        'variant=critical, size=small',
                        'variant=success, size=small',
                        'variant=warning, size=small',
                    ],
                },
                { component: 'Widget/Punctuality/DirectionLabel', variants: [] },
                {
                    component: 'Widget/Punctuality/KpiDirection',
                    variants: [
                        'direction=arrivals, layout=stacked',
                        'direction=departures, layout=stacked',
                    ],
                },
                {
                    component: 'Widget/Stat/SeverityBar',
                    variants: ['status=success', 'status=warning'],
                },
                {
                    component: 'Widget/Stat/TrendMeasure',
                    variants: [
                        'size=inline, trend=critical, labelPosition=inline, emphasis=default',
                        'size=inline, trend=success, labelPosition=inline, emphasis=default',
                        'size=small, trend=critical, labelPosition=inline, emphasis=default',
                        'size=small, trend=success, labelPosition=inline, emphasis=default',
                    ],
                },
            ],
        },
        'size=S, detailed=on': {
            container: 'gap-s w-[19.5rem] items-start',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                cols: 'gap-s items-start',
                departures: 'gap-s items-start',
                arrivals: 'gap-s items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [
                {
                    component: 'SeverityItem',
                    variants: [
                        'variant=critical, size=small',
                        'variant=success, size=small',
                        'variant=warning, size=small',
                    ],
                },
                { component: 'Widget/Punctuality/DirectionLabel', variants: [] },
                {
                    component: 'Widget/Punctuality/KpiDirection',
                    variants: [
                        'direction=arrivals, layout=stacked',
                        'direction=departures, layout=stacked',
                    ],
                },
                {
                    component: 'Widget/Stat/SeverityBar',
                    variants: ['status=success', 'status=warning'],
                },
                {
                    component: 'Widget/Stat/TrendMeasure',
                    variants: [
                        'size=inline, trend=critical, labelPosition=inline, emphasis=default',
                        'size=inline, trend=success, labelPosition=inline, emphasis=default',
                        'size=small, trend=critical, labelPosition=inline, emphasis=default',
                        'size=small, trend=success, labelPosition=inline, emphasis=default',
                    ],
                },
            ],
        },
        'size=tile, detailed=off': {
            container: 'gap-s w-[21.5rem] items-start',
            label: '',
            icon: '',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                cols: 'gap-m items-start',
                departures: 'gap-s items-start',
                arrivals: 'gap-s items-start',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [
                {
                    component: 'SeverityItem',
                    variants: [
                        'variant=critical, size=small',
                        'variant=success, size=small',
                        'variant=warning, size=small',
                    ],
                },
                { component: 'Widget/Punctuality/DirectionLabel', variants: [] },
                {
                    component: 'Widget/Punctuality/KpiDirection',
                    variants: [
                        'direction=arrivals, layout=stacked',
                        'direction=departures, layout=stacked',
                    ],
                },
                {
                    component: 'Widget/Stat/SeverityBar',
                    variants: ['status=success', 'status=warning'],
                },
                {
                    component: 'Widget/Stat/TrendMeasure',
                    variants: [
                        'size=inline, trend=critical, labelPosition=inline, emphasis=default',
                        'size=inline, trend=success, labelPosition=inline, emphasis=default',
                        'size=small, trend=critical, labelPosition=inline, emphasis=default',
                        'size=small, trend=success, labelPosition=inline, emphasis=default',
                    ],
                },
            ],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
